import { Component, OnInit } from '@angular/core';
import { Router} from '@angular/router';
import { PopoverController } from '@ionic/angular';
import { NavController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { DetailNilaiPage } from '../detail-nilai/detail-nilai.page';
import{ApiService} from '../../../services/api.service';
@Component({
  selector: 'app-nilai-siswa',
  templateUrl: './nilai-siswa.page.html',
  styleUrls: ['./nilai-siswa.page.scss'],
})
export class NilaiSiswaPage implements OnInit {

  constructor(private modalCtrl:ModalController, private navCtrl:NavController, private api:ApiService,private popover:PopoverController, private router:Router) { }

  ngOnInit() {
    this.getDataTingkat();    
    this.getKurikulum();
    this.getTahunPelajaran();
  }
  
  tingkat:any=2;
  tahun:any;
  semester:any='GASAL';
  dataTingkat:any=[];
  getDataTingkat()
  {
    this.api.data('kelas/tingkat','get','').subscribe(data=>{
      this.dataTingkat=data;
      this.getUserData();
    })
  }
  parseDataTingkat(data)
  {
    for(var i=0; i<data.length; i++)
    {      
      var dd={
        tingkatID:data[i].id,
        semester:'GASAL',
        nama:data[i].nama
      };
      this.dataTingkat.push(dd);
    }
  }
  tahunPelajaran:any;
  getTahunPelajaran()
  {
      this.api.data('akademik/tahun','get','').subscribe(data=>{
          this.tahunPelajaran=data;
      })
  }
  userData:any={};
  getUserData()
  {
    this.api.data('user/me','get','').subscribe(data=>{
      this.userData=data;
      this.parseUserData(data);
    },error=>{
        this.router.navigate(['/page/tabs/tab2']);
    })
  }
  parseUserData(data)
  {
    this.tingkat=data.tingkat;
    this.getDataNilai(this.tingkat,data.id);
  }
  dataNilai:any={};
  getDataNilai(kelasID,siswaID){
    this.api.data('nilai/siswa?siswaID='+siswaID+'&tingkatID='+kelasID,'get','').subscribe(data=>{
      this.parseNilai(data);     
    })
  }
  listTahun:any=[];
  parseNilai(data)
  {
    this.listTahun=[];
    for(var i=0; i<this.dataTingkat.length; i++)
    {
      this.dataNilai[this.dataTingkat[i].id]={};
    }
    if(this.dataNilai[this.tingkat]==undefined)
    this.dataNilai[this.tingkat]={};      
    for(var i=0; i<data.length; i++)
    {
      var mapelID=data[i].mapelID;
      var dt={
        rapot_angka:data[i].rapot_angka,
        rapot_predikat:data[i].rapot_predikat,
        rapot_deskripsi:data[i].rapot_deskripsi,
        data:data[i].data
      }
      if(this.dataNilai[data[i].tingkatID][data[i].tahunID]==undefined)
      {
        this.dataNilai[data[i].tingkatID][data[i].tahunID]={'GASAL':{},'GENAP':{}};
        this.dataNilai[data[i].tingkatID][data[i].tahunID][data[i].semester]={};
        this.dataNilai[data[i].tingkatID][data[i].tahunID][data[i].semester][data[i].mapelID]=dt;
      }else{
        this.dataNilai[data[i].tingkatID][data[i].tahunID][data[i].semester][data[i].mapelID]=dt;
      }
      //get list tahun      
      if(data[i].tahunID!=undefined)
      {
        var cekIdx=this.listTahun.indexOf(data[i].tahunID);
        if(cekIdx==-1)
        {
          this.listTahun.push(data[i].tahunID);
        }
        this.tahun=this.listTahun[0];
      }
    }
    console.log(this.listTahun);
  }
  kurikulum:any={};
  getKurikulum()
  {
    this.api.data('akademik/kurikulum','get','').subscribe(data=>{
      this.kurikulum=data;
      this.getConfigKurikulum();
    })
  }
  configKurikulum:any={};
  getConfigKurikulum()
  {
    this.api.data('akademik/configkurikulum','get','').subscribe(data=>{
      this.parseConfigKurikulum(data);
    })
  }
  parseConfigKurikulum(data)
  {
    for(var i=0; i<data.length; i++)
    {
      var idxP=this.kurikulum.map(function(e){return e.id}).indexOf(data[i].kurikulumID);
      var penilaian=[], mapel=[],kurikulum;
      if(idxP!=-1){
        penilaian=this.kurikulum[idxP].penilaian;
        mapel=this.kurikulum[idxP].mapel;        
      } 
      var dt={
        kurikulumID:data[i].kurikulumID,
        formatRapot:data[i].formatRapot,
        penilaian:penilaian,
        mapel:mapel
      };
      if(this.configKurikulum[data[i].tingkat]==undefined)
      {
        this.configKurikulum[data[i].tingkat]={};
        this.configKurikulum[data[i].tingkat][data[i].tahunID]=dt;
      }else{
        this.configKurikulum[data[i].tingkat][data[i].tahunID]=dt;
      }
    }
    console.log(this.configKurikulum);
  }
  kategori:any=0;
  kurikulumID:any;
  penilaianNama:any;
  getKur()
  {
    var config=this.configKurikulum;
    var res={penilaian:[],mapel:[]};
    if(config!=undefined && config[this.tingkat]!=undefined && config[this.tingkat][this.tahun]!=undefined)
    {
      var penilaian=config[this.tingkat][this.tahun].penilaian;
      if(this.kategori==0)
      {
        this.kategori=penilaian[0].kode;        
      }
      this.kurikulumID=config[this.tingkat][this.tahun].kurikulumID;
      this.penilaianNama=config[this.tingkat][this.tahun].penilaian.nama;
      res={
        penilaian:penilaian,
        mapel:config[this.tingkat][this.tahun].mapel
      }
    }
    return res;
  }
  getNilai(data,tahun, semester, mapel, kategori)
  {
    if(data[tahun]!=undefined && data[tahun][semester]!=undefined && data[tahun][semester][mapel]!=undefined && data[tahun][semester][mapel].rapot_angka[kategori]!=undefined)
    {
        return data[tahun][semester][mapel].rapot_angka[kategori];
    }else{
        return '00.0';
    }
  } 
  detailTahun(t)
  {
      if(this.tahunPelajaran!=undefined)
      {
        var idx=this.tahunPelajaran.map(function(e){return e.id}).indexOf(t);
        if(idx!=-1)
        {
            return this.tahunPelajaran[idx].nama;
        }
      }
  }
  onChange()
  {      
      var siswaID=this.userData.id;     
      this.getDataNilai(this.tingkat,siswaID);
  }
  async modalNilai(mapel,nilai) {
    var idxT=this.dataTingkat.map(function(e){return e.id}).indexOf(this.tingkat);
    const modal = await this.modalCtrl.create({
      component: DetailNilaiPage,
      componentProps:{
        mapel:mapel.kode,
        mapelNama:mapel.nama,
        dataNilai:nilai,
        penilaian:this.kategori,
        tingkat:this.tingkat,
        tingkatNama:this.dataTingkat[idxT].nama,
        tahun:this.tahun,
        semester:this.semester,
        kurikulumID:this.kurikulumID,
        penilaianNama:this.penilaianNama,
        kurikulum:this.kurikulum
      }
    });
    return await modal.present();
  }
  async showKelas(ev: any) {
    const popover = await this.popover.create({
        component: MenuKelas,
        event: ev,
        animated: true,
        showBackdrop: false
    });
    await popover.present();
  }

}
@Component({
  selector: 'menu-kelas',
  templateUrl: 'menu-kelas.html'
})
export class MenuKelas {
   constructor(public popover:PopoverController)
    {

    }


}
